<template>
  <div>
    <v-dialog
      v-model="DIALOG_ATIVO"
      persistent
      width="550"
      transition="dialog-top-transition"
      content-class="bra-20"
    >
      <v-card>
        <v-card-title>
          <span>{{ editando ? "Editando" : "Cadastrando" }}</span>

          <v-spacer />

          <v-btn icon @click="fecharDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="mt-3">
          <SysProdutoAutocomplete
            v-model="editedItem.produtos"
            label="Selecione o Produto*"
            outlined
            multiple
            :disabled="editedItem.id > 0"
            :error-messages="produtosErros"
            @change="messageError = null"
            incluir_produtos_combinados
          />

          <text-field-formatador
            v-model="editedItem.tempo_cobertura"
            label="Informe o Tempo de Cobertura*"
            outlined
            inteiro
            :remover-valor-irrelevante="true"
            :error-messages="tempoCoberturaErros"
            @focus="$event.target.select()"
            @keyup.enter="salvar()"
          ></text-field-formatador>
        </v-card-text>

        <v-card-actions class="d-flex mt-n5">
          <v-spacer />
          <v-btn text color="primary" @click="salvar()"> salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import SysProdutoAutocomplete from "../../../utils/crud/SysProdutoAutocomplete";
import TextFieldFormatador from "../../../utils/TextFieldFormatadorDeValor";
import { required, minValue, maxValue } from "vuelidate/lib/validators";
import TempoCoberturaPorProduto from "../../../../api/compras/TempoCoberturaPorProduto";

export default {
  name: "DialogCurvasProdutos",
  components: {
    SysProdutoAutocomplete,
    TextFieldFormatador,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    itemParaEdicao: {
      type: Object,
    },
  },
  data: () => ({
    messageError: null,
    editedItem: {
      id: "",
      produtos: [],
      tempo_cobertura: "",
    },
  }),
  watch: {
    itemParaEdicao(item) {
      const { id, idproduto, tempo_cobertura } = item;
      this.editedItem = Object.assign(
        {},
        { id, produtos: [`${idproduto}`], tempo_cobertura }
      );
    },
  },
  validations: {
    messageError: {
      duplicated() {
        return this.messageError === null;
      },
    },
    editedItem: {
      produtos: {
        required,
      },
      tempo_cobertura: {
        required,
        minValue: minValue(1),
        maxValue: maxValue(99999999),
      },
    },
  },
  computed: {
    editando() {
      return this.editedItem.id && this.editedItem.id > 0;
    },
    DIALOG_ATIVO: {
      get() {
        return this.modelValue;
      },
      set(valor) {
        this.$emit("update:modelValue", valor);
      },
    },
    produtosErros() {
      const errors = [];
      if (!this.$v.editedItem.produtos.$dirty) return errors;
      !this.$v.editedItem.produtos.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.messageError.duplicated &&
        errors.push("Tentativa de cadastro duplicado.");
      return errors;
    },
    tempoCoberturaErros() {
      const errors = [];
      if (!this.$v.editedItem.tempo_cobertura.$dirty) return errors;
      !this.$v.editedItem.tempo_cobertura.required &&
        errors.push("Campo Obrigatório.");
      !this.$v.editedItem.tempo_cobertura.minValue &&
        errors.push("Valor mínimo é 1.");
      !this.$v.editedItem.tempo_cobertura.maxValue &&
        errors.push("Valor máximo é 99.999.999.");
      return errors;
    },
  },
  methods: {
    salvar() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const headers = this.Helpers.iniciarRequisicao();

        this.$store.dispatch(
          "loading/addRequisicao",
          TempoCoberturaPorProduto.store(headers, this.editedItem)
            .then((response) => {
              const { token, messageError } = response.data;
              localStorage.token = token;

              if (!messageError) {
                this.fecharDialog();
                this.$emit("atualizar-lista", true);
              } else {
                this.messageError = messageError;
              }
            })
            .catch(() => this.Helpers.logout())
        );
      }
    },
    fecharDialog() {
      this.DIALOG_ATIVO = false;
      this.messageError = null;
      this.$v.$reset();
      this.editedItem = {
        id: "",
        produtos: [],
        tempo_cobertura: "",
      };
    },
  },
};
</script>

<style>
</style>
